<template>
    <div>
        <div v-if="isshow">
            <el-card class="box-card" style="margin-bottom: 10px;width:600px;">
                <div slot="header" class="clearfix">
                    <span>参数</span>
                </div>
                <el-form ref="formData" label-width="20px">
                    <div style="display: flex;">
                        <div style="width: 60%;margin-right:20px;">
                            <el-form-item>
                                <el-select
                                    v-model="formData.website"
                                    ref="carrerSelect"
                                    style="width: 100%;"
                                    size="small"
                                    filterable
                                >
                                    <el-option
                                        v-for="item in us_arr"
                                        :key="item.us"
                                        :label="item.title"
                                        :value="item.title"
                                        :disabled="item.disabled">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-input style="width: 100%;" placeholder="产品ASIN" v-model="formData.asin" size="small" @change="inputChange" v-loading="inputloading"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <span style="font-size: 12px;color: #aaa;">注：请确保亚马逊网站是登录状态,否则可能会导致爬取1-5星的数据读不到2~9页的评论(即最多只会读第一页的50条评论数据)</span>
                            </el-form-item>
                            <!-- <el-form-item>
                                <el-input-number v-model="formData.num" :step="10" :max="5000" size="small"></el-input-number>
                            </el-form-item> -->
                        </div>
                        <div style="width: 30%;">
                            <img v-if="img" style="width: 100%;max-width: 132px;" :src="img" alt="">
                        </div>
                    </div>
                    <el-form-item>
                        <div class="ic-textarea-title" style="margin-top: 10px;">
                            <div style="margin-top: auto!important;width: 100%!important;">
                                <el-button type="primary" @click="checkKeywords" :disabled="inputloading" size="small">开始读取</el-button>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </el-card>
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>结果</span>
                    <el-button style="float: right; padding: 3px 0;" size="mini" type="primary" @click="onExcel">导出Excel</el-button>
                    <download-excel
                        id="download_excel"
                        class = "export-excel-wrapper"
                        :data = "json_data"
                        :fields = "json_fields"
                        style="display: none;"
                        name = "评价查找数据.xls">
                    </download-excel>
                </div>
                <div class="table-responsive">
                    <div class="progress" id="progress">
                        <span style="margin-right: 10px">获取数据的进度：</span>
                        <el-progress :percentage="0" style="width: 60%;"></el-progress>
                        <span id="progress_txt"></span>
                    </div>
                    <table class="table-bordered" id="table-bordered">
                        <thead>
                            <tr>
                                <th class="th" style="width: 140px;">
                                    <div class="th-title">
                                        <span>用户名</span>
                                    </div>
                                </th>
                                <th class="th" style="width: 80px;">
                                    <div class="th-title">
                                        用户头像
                                    </div>
                                </th>
                                <th class="th" style="width: 80px;">
                                    <div class="th-title">
                                        星级
                                    </div>
                                </th>
                                <th class="th" style="min-width: 200px;">
                                    <div class="th-title">
                                        评论标题
                                    </div>
                                </th>
                                <th class="th" style="min-width: 400px;">
                                    <div class="th-title">
                                        评论内容
                                    </div>
                                </th>
                                <th class="th" style="width: 110px;">
                                    <div class="th-title">
                                        商品属性
                                    </div>
                                </th>
                                <th class="th" style="width: 90px;">
                                    <div class="th-title">
                                        评论ASIN
                                    </div>
                                </th>
                                <th class="th" style="width: 80px;">
                                    <div class="th-title">
                                        评论国家
                                    </div>
                                </th>
                                <th class="th" style="width: 80px;">
                                    <div class="th-title">
                                        评论时间
                                    </div>
                                </th>
                                <th class="th">
                                    <div class="th-title" style="min-width: 80px;">
                                        评论图片
                                    </div>
                                </th>
                                <th class="th">
                                    <div class="th-title" style="min-width: 80px;">
                                        评论视频链接
                                    </div>
                                </th>
                                <th class="th">
                                    <div class="th-title">
                                        标签
                                    </div>
                                </th>
                                <th class="th">
                                    <div class="th-title">
                                        帮助
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody id="tbody_id" style="height: 40px;line-height: 40px">
                            <tr>
                                <td colspan="13">
                                    <div style="text-align: center!important;">等你开始搜索。</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-card>
        </div>
        <crx-view v-else></crx-view>
    </div>
</template>

<script>
import * as api from "@/api/Product/Product";
import CrxView from "@/components/crxView";
import { checkPlug } from "@/utils/method";
export default {
    components: { CrxView },
    data() {
        return {
            formData: {
                website: "www.amazon.com",
                asin: ""
                // num: 1000
            },
            json_fields: {
                用户名: "name",
                用户链接: "link",
                用户头像: "user_head",
                评论链接: "link_evaluate",
                评论星级: "star",
                评论标题: "title",
                评论内容: "text",
                商品属性: "attribute",
                评论ASIN: "asin",
                评论国家: "state",
                评论时间: "date",
                评论图片链接: "review_pic",
                评论视频链接: "review_video",
                标签: "review_label",
                帮助: "review_helpful"
            },
            json_data: [],
            json_meta: [
                [
                    {
                        key: "charset",
                        value: "utf- 8"
                    }
                ]
            ],
            us_arr: [
                {
                    us: "US",
                    title: "www.amazon.com"
                },
                {
                    us: "UK",
                    title: "www.amazon.co.uk"
                },
                {
                    us: "DE",
                    title: "www.amazon.de"
                }
                // {
                //     us: "CA",
                //     title: "www.amazon.ca",
                //     disabled: true
                // },
                // {
                //     us: "MX",
                //     title: "www.amazon.com.mx",
                //     disabled: true
                // },
                // {
                //     us: "FR",
                //     title: "www.amazon.fr",
                //     disabled: true
                // },
                // {
                //     us: "IT",
                //     title: "www.amazon.it",
                //     disabled: true
                // },
                // {
                //     us: "ES",
                //     title: "www.amazon.es",
                //     disabled: true
                // },
                // {
                //     us: "JP",
                //     title: "www.amazon.co.jp",
                //     disabled: true
                // },
                // {
                //     us: "IN",
                //     title: "www.amazon.in",
                //     disabled: true
                // },
                // {
                //     us: "AU",
                //     title: "www.amazon.com.au",
                //     disabled: true
                // }
            ],
            inputloading: false,
            img: null,
            isshow: false,
            asin: "",
            arr: []
        };
    },
    mounted() {
        checkPlug(()=>this.isshow = true, ()=>this.$downLoadPlug())
    },
    methods: {
        xpath_(xpathToExecute, data) {
            var result = [];
            var nodesSnapshot = document.evaluate(
                xpathToExecute,
                data,
                null,
                XPathResult.ORDERED_NODE_SNAPSHOT_TYPE,
                null
            );
            for (var i = 0; i < nodesSnapshot.snapshotLength; i++) {
                result.push(nodesSnapshot.snapshotItem(i));
            }
            return result;
        },
        //导出excel
        onExcel() {
            let aresults_detail_list = this.xpath_(
                "//tbody[@id='tbody_id']/tr",
                document
            );
            let excelarr = [];
            try {
                for (var i = 0; i < aresults_detail_list.length; i++) {
                    let tds = this.xpath_("./td", aresults_detail_list[i]);
                    let obj = {};
                    let link = document
                        .evaluate(
                            "./a/@href",
                            tds[0],
                            null,
                            XPathResult.ANY_TYPE,
                            null
                        )
                        .iterateNext().value;
                    if (link == "javascript:void(0);") {
                        obj.link = "";
                    } else {
                        obj.link = link;
                    }
                    obj.name = document
                        .evaluate(
                            "./a/span",
                            tds[0],
                            null,
                            XPathResult.ANY_TYPE,
                            null
                        )
                        .iterateNext().innerText;
                    obj.user_head = document
                        .evaluate(
                            "./img/@src",
                            tds[1],
                            null,
                            XPathResult.ANY_TYPE,
                            null
                        )
                        .iterateNext().value;
                    obj.star = document
                        .evaluate(
                            "./span",
                            tds[2],
                            null,
                            XPathResult.ANY_TYPE,
                            null
                        )
                        .iterateNext().innerText;
                    let link_evaluate = document
                        .evaluate(
                            "./a/@href",
                            tds[3],
                            null,
                            XPathResult.ANY_TYPE,
                            null
                        )
                        .iterateNext().value;
                    if (link_evaluate == "javascript:void(0);") {
                        obj.link_evaluate = "";
                    } else {
                        obj.link_evaluate = link_evaluate;
                    }
                    obj.title = document
                        .evaluate(
                            "./a/span",
                            tds[3],
                            null,
                            XPathResult.ANY_TYPE,
                            null
                        )
                        .iterateNext().innerText;
                    obj.text = document
                        .evaluate(
                            "./a/span",
                            tds[4],
                            null,
                            XPathResult.ANY_TYPE,
                            null
                        )
                        .iterateNext().innerText;
                    obj.attribute = document
                        .evaluate(
                            "./span",
                            tds[5],
                            null,
                            XPathResult.ANY_TYPE,
                            null
                        )
                        .iterateNext().innerText;
                    obj.asin = document
                        .evaluate(
                            "./span",
                            tds[6],
                            null,
                            XPathResult.ANY_TYPE,
                            null
                        )
                        .iterateNext().innerText;
                    obj.state = document
                        .evaluate(
                            "./span",
                            tds[7],
                            null,
                            XPathResult.ANY_TYPE,
                            null
                        )
                        .iterateNext().innerText;
                    obj.date = document
                        .evaluate(
                            "./span",
                            tds[8],
                            null,
                            XPathResult.ANY_TYPE,
                            null
                        )
                        .iterateNext().innerText;
                    obj.review_video = document
                        .evaluate(
                            "./span",
                            tds[10],
                            null,
                            XPathResult.ANY_TYPE,
                            null
                        )
                        .iterateNext().innerText;
                    obj.review_label = document
                        .evaluate(
                            "./span",
                            tds[11],
                            null,
                            XPathResult.ANY_TYPE,
                            null
                        )
                        .iterateNext().innerText;
                    obj.review_helpful = document
                        .evaluate(
                            "./span",
                            tds[12],
                            null,
                            XPathResult.ANY_TYPE,
                            null
                        )
                        .iterateNext().innerText;
                    let review_pic_arr = this.xpath_("./img/@src", tds[9]);
                    let review_pic_msg = null;
                    for (let j = 0; j < review_pic_arr.length; j++) {
                        if (review_pic_msg == null) {
                            review_pic_msg = review_pic_arr[j].value;
                        } else {
                            review_pic_msg =
                                review_pic_msg +
                                "\n" +
                                "\n" +
                                review_pic_arr[j].value;
                        }
                    }
                    obj.review_pic = review_pic_msg;
                    excelarr.push(obj);
                }
                this.json_data = excelarr;
                if (excelarr.length == 0) {
                    return this.$message({
                        type: "error",
                        message: "请获取需要导出的数据！"
                    });
                }
                var downloadExcel = document.getElementById("download_excel");
                setTimeout(function() {
                    downloadExcel.click();
                }, 100);
            } catch (err) {
                return this.$message({
                    type: "error",
                    message: "请获取需要导出的数据！"
                });
            }
        },
        //爬取
        checkKeywords() {
            if (this.formData.asin == "") {
                return this.$message({
                    type: "error",
                    message: "请输入合法的产品ASIN"
                });
            }
            var tbody = document.getElementById("tbody_id");
            tbody.remove();
            var table = document.getElementById("table-bordered");
            var tbody_new = document.createElement("tbody");
            tbody_new.id = "tbody_id";
            table.appendChild(tbody_new);
            var div = document.getElementById("div_evaluate");
            let obj = {};
            obj.website = this.formData.website;
            obj.asin = this.formData.asin;
            // obj.num = this.formData.num;
            div.innerText = JSON.stringify(obj);
            div.click();
        },
        //获取ASIN内容数据
        inputChange(val) {
            if (val.length < 10) {
                return;
            }
            this.inputloading = true;
            let us_arr_value = null;
            for (let i = 0; i < this.us_arr.length; i++) {
                if (this.us_arr[i].title == this.formData.website) {
                    us_arr_value = this.us_arr[i].us;
                    break;
                }
            }
            api.asin_info({ asin: val, country_code: us_arr_value })
                .then(res => {
                    this.inputloading = false;
                    if (res.code === 0) {
                        this.img = res.data.image_url;
                    } else {
                        this.formData.asin = "";
                        this.img = null;
                    }
                })
                .catch(() => {
                    this.inputloading = false;
                    this.$message({
                        type: "error",
                        message: "网络出现问题，请刷新页面！"
                    });
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.progress {
    display: none;
    margin-bottom: 10px;
    align-items: center;
}
.el-button--mini {
    padding: 5px 5px !important;
}
/deep/ .el-card__header {
    padding: 10px 20px;
}
/deep/ .el-checkbox {
    margin-right: 10px;
}
/deep/ .el-form-item {
    margin-bottom: 4px;
}
.pushed-folders {
    line-height: 19px !important;
    min-height: 28px;
    display: inline-block;
    vertical-align: top;
    border: 1px solid transparent;
}
.pushed-keyword {
    font-size: 14px;
    font-weight: 700;
    color: #343a40;
    display: inline-block;
    vertical-align: middle;
    padding: 3px 7px 3px 3px;
    margin: 5px 0 0 5px;
    border-radius: 4px;
    border: 1px solid #e4e5e7;
    background-color: #fff;
    i {
        margin-left: 5px;
        cursor: pointer;
        font-weight: 700;
    }
}
.dropdown-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 6px 6px 11px;
    font-size: 14px;
    font-weight: 400;
    color: #343a40;
    white-space: nowrap;
    user-select: none;
    cursor: pointer;
    box-sizing: border-box;
    .dropdown-item-txt {
        width: 132px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    span {
        padding-right: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        box-sizing: border-box;
    }
}
.dropdown-item:hover {
    background: rgb(240, 240, 240);
}
.dropdown-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-weight: 700;
    color: #003873;
    line-height: 1.2;
    margin: 0;
    padding: 6px 8px 6px 11px;
    cursor: default;
    user-select: none;
}
.dropdown-header__title {
    font-size: 14px;
    font-weight: 600;
    color: #8c8c8c;
}
.dropdown-items {
    overflow-y: auto;
    min-height: 0;
    max-height: 276px;
    transition: height 400ms cubic-bezier(0.5, 0, 0.2, 1);
}
.select-popper {
    .popper__arrow {
        display: none !important;
    }
    margin-top: 3px !important;
    padding: 5px 0 !important;
    box-sizing: border-box !important;
}
.folder {
    color: #003873;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 6px 6px 11px;
    font-size: 14px;
    font-weight: 700;
    white-space: nowrap;
    user-select: none;
    cursor: pointer;
}
.folder:hover {
    background: rgb(240, 240, 240);
}
.button-plus {
    width: 163px;
    cursor: pointer;
    height: 28px;
    line-height: 28px;
    font-size: 13px;
    padding: 0 5.5px;
    background: #fff;
    box-sizing: border-box;
    border: 1px solid #dcdfe6;
    color: #606266;
    font-weight: 500;
    border-radius: 4px;
}
.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}
.clearfix:after {
    clear: both;
}

.box-card {
    width: 100%;
}
/deep/ ::-webkit-scrollbar {
    width: 7px;
    height: 5px;
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-track-piece {
    background-color: #ffff;
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-thumb:vertical {
    height: 5px;
    background-color: rgba(144, 147, 153, 0.5);
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-thumb:horizontal {
    width: 7px;
    background-color: rgba(144, 147, 153, 0.5);
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
</style>
